import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Elements';
import { ultraWideModalStyles } from '@/components/Elements/Modal/customStyles';
import { PaymentsModal } from '@/components/Elements/PaymentsModal';

export type IncompletePaymentRequiresActionErrorModalProps = {
  onConfirmAction: () => void;
  onCancelAction: () => void;
  isOpen?: boolean;
};

export const IncompletePaymentRequiresActionErrorModal = ({
  onConfirmAction,
  onCancelAction,
  isOpen = false,
}: IncompletePaymentRequiresActionErrorModalProps) => {
  const [disabledButtons, setDisabledButtons] = useState(false);
  const { t } = useTranslation();

  const onDefaultConfirmAction = () => {
    setDisabledButtons(true);
    onConfirmAction && onConfirmAction();
  };

  const onDefaultCancelAction = () => {
    setDisabledButtons(true);
    onCancelAction && onCancelAction();
  };

  const getCancelButton = () => (
    <Button
      variant="ghost"
      type="button"
      onClick={onDefaultCancelAction}
      size="md"
      className="!mx-3.5 !w-1/2"
      disabled={disabledButtons}
    >
      {t('IncompletePaymentRequiresActionErrorModal.cancelButton')}
    </Button>
  );

  const getConfirmButton = () => (
    <Button
      variant="primary"
      type="button"
      onClick={onDefaultConfirmAction}
      size="md"
      className="!w-1/2"
      disabled={disabledButtons}
    >
      {t('IncompletePaymentRequiresActionErrorModal.confirmButton')}
    </Button>
  );

  return (
    <PaymentsModal
      closeButton={false}
      isOpen={isOpen}
      style={ultraWideModalStyles}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onDefaultCancelAction}
    >
      <div className="w-full h-full text-left pl-8">
        <div className="text-2xl text-black font-black">
          {t('IncompletePaymentRequiresActionErrorModal.title')}
        </div>
        <div className="mb-12 text-lg">
          {t('IncompletePaymentRequiresActionErrorModal.description')}
        </div>
        <div className="mb-4 flex items-center justify-end w-full">
          {getCancelButton()}
          {getConfirmButton()}
        </div>
        <div className="mb-3 flex items-left mb-10 lg:mb-0 w-full">
          {t('IncompletePaymentRequiresActionErrorModal.disclaimer')}
        </div>
      </div>
    </PaymentsModal>
  );
};
